import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
} from "assets/jss/material-kit-react.js";
const cardHeaderStyle = {
  cardHeader: {
    borderRadius: "50px",
    padding: "5px",
    marginLeft: "25%",
    marginRight: "25%",
    marginTop: "-30px",
    border: "0",
    marginBottom: "0",
    textAlign: "center",
    fontSize: "1.5em",
  },
  cardHeaderPlain: {
    marginLeft: "0px",
    marginRight: "0px",
  },
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
};

export default cardHeaderStyle;
